/**
 * One icon per activity type, so a list of them reads at a glance. The types
 * are fixed in `@forsys/shared`, and so is this map — a new type that is not
 * here is a compile error.
 */
import EventOutlinedIcon from '@mui/icons-material/EventOutlined';
import FlagOutlinedIcon from '@mui/icons-material/FlagOutlined';
import MailOutlinedIcon from '@mui/icons-material/MailOutlined';
import PhoneOutlinedIcon from '@mui/icons-material/PhoneOutlined';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import type { SvgIconProps } from '@mui/material/SvgIcon';
import type { ActivityType } from '@forsys/shared';

const ICONS: Record<ActivityType, typeof PhoneOutlinedIcon> = {
  call: PhoneOutlinedIcon,
  meeting: EventOutlinedIcon,
  task: TaskAltIcon,
  email: MailOutlinedIcon,
  deadline: FlagOutlinedIcon,
};

export function ActivityIcon({ type, ...props }: { type: ActivityType } & SvgIconProps) {
  const Icon = ICONS[type];
  return <Icon fontSize="small" {...props} />;
}
